import {
    useNavigate,
    useParams
} from "react-router-dom";
import * as yup from "yup";
import { ILocaleStrings } from "loc/locale.interfaces";
import { useL10n } from "context/l10n-context";
import Form from "components/forms/form/form";
import PermissionsLevelField from "components/settings/permissions/application-roles/permission-level-field/permissions-level-field";

export default function ApplicationRolePermissionLevel() {
    const { t } = useL10n<ILocaleStrings>();
    const params = useParams();
    const navigate = useNavigate();

    const schema = yup.object().shape({ //<IApplicationRole>
        id: yup
            .number()
            .required(),
        permissionLevel: yup
            .string()
            .optional()
    });

    const onSuccess = () => {
        navigate("/settings/permissions/application-roles");
    }

    const onCancel = () => {
        navigate("/settings/permissions/application-roles");
    }

    return (
        <Form
            schema={schema}
            getExistingApiUrl={`/api/settings/permissions/application-roles/${params.id}`}
            apiUrl={`/api/settings/permissions/application-roles/${params.id}`}
            method="PUT"
            onSuccess={onSuccess}
            onCancel={onCancel}
            submitLabel="save"
            submittingLabel="saving"
            cancelLabel="cancel">
            <PermissionsLevelField
                label="name"
                fieldName="permissionLevel"
                required />
        </Form>
    );
}